export default __webpack_public_path__ + "static/media/waiting-for-pickup.d28b85f0.svg";